<template>
  <div>
    <agent-home v-if="isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN" />
    <normal-home v-else />
  </div>
</template>

<script>
import normalHome from "@/views/dashboard/normal-home.vue";
import agentHome from "@/views/dashboard/agent-home.vue";
import { getLogionUserInfo } from "@/utils/auth";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";

export default {
  data() {
    return {
      isAgentLogin: null,
    };
  },
  created() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    console.log('isAgentLogin-----', this.isAgentLogin);
  },
  computed: {
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    },
  },

  components: {
    normalHome,
    agentHome,
  },
};
</script>
